export default __webpack_public_path__ + "locales/hy-AM/FormFillingTipsDialog.json?hash=0379503c08e3a5ad71ef4f08014f0bf3";